import { logError } from '@zg-rentals/log-error';

type ErrorContext = Record<string, unknown>;

type AppError = {
  message?: string;
  context?: ErrorContext;
  conversationId?: string;
  error?: string;
};

const isApiResponseError = (err: any): boolean => {
  return Boolean(err.response);
};

const isApiRequestError = (err: any): boolean => {
  return Boolean(err.request);
};

const isUserAuthError = (err: any): boolean => {
  return (err && err.message && err.message.includes('User')) || (err && err.message && err.message.includes('user'));
};

const getUsefulReqInfo = (req: any): any => {
  return {
    url: req.originalUrl,
    ip: req.ip,
    referer: req.get('referer'),
    userAgent: req.get('user-agent'),
    host: req.get('host'),
    traceId: req.id,
  };
};

// TODO: improve typing
const formatForLog = (err: any): any => {
  return {
    error: {
      code: err?.code,
      stack: err?.stack,
      message: err?.message,
      data: err?.data,
    },
  };
};

const logAppError = ({ conversationId = '', error = '', context = {}, message = '' }: AppError): void => {
  if (isUserAuthError(error)) {
    return;
  }

  const formattedError = formatForLog(error);

  logError({ error, context: { conversationId, formattedError, message, ...context } });
};

// TODO: improve typing
const logApiResponseError = (err: any, req: any, context: ErrorContext): void => {
  logError({
    error: err,
    context: {
      info: 'logging api response error',
      responseStatus: err?.response?.status,
      responseHeaders: err?.response?.headers,
      ...(req ? getUsefulReqInfo(req) : {}),
      ...context,
    },
  });
};

// TODO: improve typing
const logApiRequestError = (err: any, req: any, context: ErrorContext): void => {
  logError({
    error: err,
    context: {
      info: 'logging api request error',
      axiosConfig: err?.config,
      ...(req ? getUsefulReqInfo(req) : {}),
      ...context,
    },
  });
};

// TODO: improve typing
const handleError = ({
  error,
  req,
  context = {},
}: {
  error: any;
  req?: any;
  context?: Record<string, unknown>;
}): void => {
  if (isApiResponseError(error)) {
    logApiResponseError(error, req, context);
  } else if (isApiRequestError(error)) {
    logApiRequestError(error, req, context);
  } else {
    logError({ error, context: { info: 'logging general error', ...context } });
  }
};

export {
  handleError,
  formatForLog,
  logApiRequestError,
  logApiResponseError,
  logAppError,
  getUsefulReqInfo,
  isApiResponseError,
  isApiRequestError,
  isUserAuthError,
};
